import AddressLine from "./AddressLine";
import InfoMenu from "./InfoMenu";
import BlankTr from "./BlankTr";

export default function InfoBox({
  leyendRef,
  dim,
  openBox2,
  address,
  getFeat,
  points_layer,
  handleClickAddr,
  focusPoint,
  updateCheck,
  closeGPS,
  goTo,
  focusLayer,
  openWindow,
  buttonsMenu,
  scrollMenu,
}) {
  return (
    <div
      ref={leyendRef}
      className="mapBox"
      style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        width: dim.list[0] + "%",
        height: dim.list[1] + "%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0px 0px 8px black",
      }}
    >
      <InfoMenu
        openBox2={openBox2}
        buttonsMenu={buttonsMenu}
        scrollMenu={scrollMenu}
      />
      <div style={{ overflowY: "auto", overflowX: "hidden", flex: 1 }}>
        <table
          cellPadding={0}
          cellSpacing={0}
          style={{ position: "relative", width: "100%" }}
        >
          <tbody>
            {address.list.map((o, index) => (
              <AddressLine
                key={index}
                index={index}
                data={o}
                getFeat={getFeat}
                points_layer={points_layer}
                address={address}
                handleClickAddr={handleClickAddr}
                focusPoint={focusPoint}
                updateCheck={updateCheck}
                closeGPS={closeGPS}
                goTo={goTo}
                focusLayer={focusLayer}
                openWindow={openWindow}
              />
            ))}
            <BlankTr />
          </tbody>
        </table>
      </div>
    </div>
  );
}
